import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import SelectAsync from 'react-select/async';
import { Button } from "reactstrap"

export default class InputAndOutputPersons extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'inputandoutputperson',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 10,
            phrase: '',
            filters: {
                comId: 0,
                type: 0,
                month: 0,
            }

        };

    }
    setTypeRec(v) {
        this.state.filters.month = v;
        this.setState({ data: this.state.data });
    }
    setStartDate(v) {
        if (v != null) {
            let data = v.toString();
            this.state.filters.startDate = data;
            this.state.filters.startDateM = v.toDate();
        }
        else {
            this.state.filters.startDate = null;
            this.state.filters.startDateM = null;
        }

        this.setState({ data: this.state.data });
    }


    recoveryData(e) {
        this.state.phrase = "";
        this.state.filters.comId = 0;
        this.state.filters.type = 0;
        this.state.filters.month = 0;
        this.refreshData(e);
    }
    loadLookupUnit(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/personnel/getlookupunit/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };

    loadPersonsOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getpersons/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status === 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.fullName
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    componentDidMount() {
        this.refreshData();
    }



    renderForm() {
        return (
            <div>
                <div className="nk-content-body">
                    <div className="nk-block-head nk-block-head-sm">
                        <div className="nk-block-between">
                            <div className="nk-block-head-content">
                                <h3 className="nk-block-title page-title">فهرست تایم شیت</h3>
                                <div className="nk-block-des text-soft">
                                    <p>شما {this.money(this.state.data.recordsCount)} تایم شیت ثبت شده دارید</p>
                                </div>
                            </div>
                            <div className="nk-block-head-content">

                                <div className="toggle-wrap nk-block-tools-toggle">
                                    <li>
                                        <NavLink to="/inputandoutputperson/new/" className="btn btn-primary"><em className="icon ni ni-download-cloud"></em><span>تایم شیت جدید</span></NavLink>
                                    </li>
                                    {/*<a href="/inputandoutputperson/new" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r">تایم شیت جدید</em></a>*/}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="nk-block">
                        <div className="card card-bordered card-stretch ">
                            <div className="card-inner-group">
                                <div className="card-inner position-relative card-tools-toggle">
                                    <div className="card-title-group">
                                        <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                            <div className="form-inline flex-nowrap">
                                                <div className="row g-3">
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">انتخاب پرسنل</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync

                                                                    defaultValue={this.state.filters.comId > 0 ? [{ value: this.state.filters.comId, label: this.state.filters.name }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب سهم"
                                                                    defaultOptions
                                                                    isSearchable
                                                                    loadOptions={this.loadPersonsOptions}
                                                                    onChange={e => this.state.filters.comId = e.value}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">واحد اداری</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync

                                                                    defaultValue={this.state.filters.type > 0 ? [{ value: this.state.filters.type, label: this.state.filters.name }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب واحد اداری"
                                                                    defaultOptions
                                                                    isSearchable
                                                                    loadOptions={this.loadLookupUnit}
                                                                    onChange={e => this.state.filters.type = e.value}
                                                                />  
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">ماه</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" type="text" defaultValue={this.state.filters.type} onChange={e => this.setTypeRec(parseInt(e.target.value))}>
                                                                    <option value="0">انتخاب ماه</option>
                                                                    <option value="1">فروردین</option>
                                                                    <option value="2">اردیبهشت</option>
                                                                    <option value="3">خرداد</option>
                                                                    <option value="4">تیر</option>
                                                                    <option value="5">مرداد</option>
                                                                    <option value="6">شهریور</option>
                                                                    <option value="7">مهر</option>
                                                                    <option value="8">آبان</option>
                                                                    <option value="9">آذر</option>
                                                                    <option value="10">دی</option>
                                                                    <option value="11">بهمن</option>
                                                                    <option value="12">اسفند</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">برای فیلتر کردن دیکه جستجو را بزنید</label>
                                                            <div className="form-control-wrap">
                                                                <div className="btn-wrap">
                                                                    <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجوی اطلاعات </button></span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">بازیابی اطلاعات</label>
                                                            <div className="form-control-wrap">
                                                                <div className="btn-wrap">
                                                                    <span className="d-none d-md-block">
                                                                        <Button onClick={e => this.recoveryData(e)} className="btn-dim" outline color="info"><em class="icon ni ni-search"></em> بازیابی اطلاعات  </Button>

                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <br></br>

                                <div className="card-inner p-0 is-dark">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col"><span className="sub-text text-center">ردیف</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center">نام و نام خانوادگی</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center">ماه</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center">جمع حضور</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">جمع اضافه کار</span></div>

                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">جمع کسر کار</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">جمع کل کارکرد</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">جمع کل ماموریت</span></div>

                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">جمع کل مرخصی</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>

                                            <div className="nk-tb-item" >
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center" >{this.genRowNumber(index)}</span>
                                                </div>

                                                <div className="nk-tb-col tb-col-lg text-center">

                                                    <span class="sub-text text-center">{record.firstName+' '+record.lastName}</span>

                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">

                                                    <span class="sub-text text-center">{record.monthsStr}</span>

                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">

                                                    <span class="sub-text text-center">{record.sumAttendance} ساعت</span>

                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">

                                                    <span class="sub-text text-center">{record.sumPlusOvertime} ساعت</span>

                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">

                                                    <span class="sub-text text-center">{record.sumWorkDeduction} ساعت</span>

                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">

                                                    <span class="sub-text text-center">{record.totalFunction} ساعت</span>

                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">

                                                    <span class="sub-text text-center">{record.totalMission} ساعت</span>

                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">

                                                    <span class="sub-text text-center">{record.totalLeave} ساعت</span>

                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li className="nk-tb-action-hidden">
                                                            <NavLink to={"/holder/edit/" + record.id + "/"} className="btn btn-trigger btn-icon" data-bs-toggle="tooltip" data-bs-placement="top" title="مشاهده و ویرایش">
                                                                <em className="icon ni ni-eye-fill"></em>
                                                            </NavLink>
                                                        </li>

                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        <li><NavLink to={"/inputandoutputperson/edit/" + record.id + "/"}><em className="icon ni ni-eye"></em><span>مشاهده و ویرایش</span></NavLink></li>
                                                                        {/*<li><a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-na"></em><span>حذف رکورد</span></a></li>*/}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.createPaging()}
                            </div>

                        </div>
                    </div>
                </div>
                {!this.isBlank(this.state.Id_to_remove) &&
                    <div className="modalBg">
                        <div className="modalInner">
                            <p>آیا از حذف آیتم انتخابی مطمئن هستید؟</p>
                            <button className="btn btn-danger" onClick={e => { this.remove(); }}>بله</button>
                            <button className="btn btn-primary mr-r-10" onClick={e => { this.setState({ id_to_remove: null }); }}>انصراف</button>
                        </div>
                    </div>
                }
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}